export default {
    init: function () {
        $("[data-slider]").each(function () {
            const container = $(this);
            let arrows = container.data("arrows") || false;
            let slides = parseInt(container.data("slides")) || 1;
            let fade = !!container.data("fade") || false;
            let autoplay = parseInt(container.data("autoplay")) || false;
            let speed = parseInt(container.data("speed")) || 1000;

            container.slick({
                arrows: arrows,
                dots: false,
                slidesToShow: slides,
                slidesToScroll: 1,
                autoplay: autoplay,
                speed: speed,
                fade: fade,
                infinite: true,
            });
        });
    },
};
